import React from 'react';
import ReactDOM from 'react-dom';
import { isBrowser, portalUri } from '../../../utils';
import './style.scss';

// export default Header;
export const HeaderPortal = ({ loggedIn = false }) => {
    if (isBrowser()) {
        const mobileLoginWrapper = document.getElementById('nav-vip-mobile');

        return mobileLoginWrapper
            ? ReactDOM.createPortal(
                  <>
                      <div className='nav-offscreen' id='subnav-my-vip-mobile'>
                          <div className='flex row subnav-content'>
                              <div id='vip-details-mobile'></div>
                              <a href='/VIP-Players-Club/Login.aspx?logout=1' className='btn btn-alt'>
                                  Log Out
                              </a>
                          </div>

                          <div id='p_lt_ctl00_LotteryMobileMenu_vipNotVerifiedMobile' className='nav-notice-box'></div>
                          <a href={portalUri + 'login/welcome-back/'} className='lnk-back'>
                              Back to News Window
                          </a>
                          <nav className='subnav-vert'>
                              <a href={portalUri + 'login/change-password/'} className='subnav-vert-item'>
                                  Login Details
                              </a>

                              <a href={portalUri + 'documents/'} className='subnav-vert-item'>
                                  My Documents
                              </a>

                              <a href={portalUri + 'my-drawings/'} id='p_lt_ctl00_LotteryMobileMenu_kycNavMyDrawings' className='subnav-vert-item'>
                                  My Drawings
                              </a>

                              <a href={portalUri + 'my-subscriptions/'} className='subnav-vert-item'>
                                  My Subscriptions
                              </a>

                              <a href={portalUri + 'responsible/gaming-limits/'} className='subnav-vert-item'>
                                  Responsible Gaming
                              </a>

                              <a href={portalUri + 'contact-preferences/'} className='subnav-vert-item'>
                                  Contact Preferences
                              </a>

                              <button id='btn-vip-players-club-mobile' className='btn btn-subnav-vert'>
                                  VIP Players Club <i className='fas fa-caret-right'></i>
                              </button>
                              <div className='subnav-vert switchable-nav subnav-off' id='subnav-vip-players-club-mobile'>
                                  <h3>VIP Players Club</h3>
                                  <a href='/VIP-Players-Club/Dashboard.aspx' className='subnav-vert-item'>
                                      Go to VIP Dashboard
                                  </a>
                                  <a href='/VIP-Players-Club/Second-Chance-Prize-Zone.aspx' className='subnav-vert-item'>
                                      Second Chance&trade;
                                  </a>
                                  <a href='/VIP-Players-Club/Coupon-Offers.aspx' className='subnav-vert-item'>
                                      Coupon Offers
                                  </a>
                                  <a href='/VIP-Players-Club/My-VIP/Edit-Email-Alerts.aspx' className='subnav-vert-item'>
                                      Email Alerts
                                  </a>
                                  <a href='/VIP-Players-Club/My-VIP/Edit-Text-Alerts.aspx' className='subnav-vert-item'>
                                      Text Alerts
                                  </a>
                                  <a href='/VIP-Players-Club/Customize-VIP-Dashboard.aspx' className='subnav-vert-item'>
                                      Customize VIP Dashboard
                                  </a>
                                  <button id='btn-back-to-main-mobile' className='btn btn-subnav-vert'>
                                      <i className='fas fa-caret-left'></i> Main Menu
                                  </button>
                              </div>
                          </nav>
                      </div>
                  </>,
                  mobileLoginWrapper
              )
            : null;
    } else {
        return null;
    }
};

export default HeaderPortal;
